// Constants for ngx

export class NgxPhoneConstants {
    public static readonly PHONE_NUMBER_AND_EXTENSION_SEPARATOR: string = 't';
    public static readonly EMPTY_PHONE_NUMBER_EXTENSION: string = 'null';

    /*
     * Ngx input element attribute: showMaskTyped
     */
    public static readonly SHOW_MASK_TYPED: boolean = true;

    /*
     * Ngx input element attribute: specialCharacters
     */
    public static readonly SPECIAL_CHARACTERS: string[] = [
        ' ',
        '(',
        ')',
        '-',
        '.',
    ];
    public static readonly SPECIAL_CHARACTERS_WITH_EXTENSION: string[] = [
        'e',
        'x',
        't',
        ' ',
        '(',
        ')',
        '-',
        '.',
    ];

    /*
     * Ngx input element attribute: dropSpecialCharacters
     */
    public static readonly DROP_SPECIAL_CHARACTERS_WITH_EXTENSION: string[] = [
        'e',
        'x',
        ' ',
        '(',
        ')',
        '-',
        '.',
    ];

    /*
     * Ngx input element attribute: placeHolderCharacter
     */
    public static readonly PLACE_HOLDER_CHARACTER: string = '_';

    /*
     * Ngx input element attribute: shownMaskExpression
     */
    public static readonly SHOWN_MASK_EXPRESSION: string = '(___) ___-____';
    public static readonly SHOWN_MASK_EXPRESSION_WITH_EXTENSION: string =
        '(___) ___-____ ext. _____';

    /*
     * Ngx input element attribute: mask
     */
    public static readonly MASK: string = '(000) 000-0000';
    public static readonly MASK_WITH_EXTENSION: string =
        '(000) 000-0000 ext. 99999';
}

export class NgxDateConstants {
    public static readonly PLACEHOLDER: string = 'mm/dd/yyyy';

    /** Pads single-digit months and days while preserving two-digit entry. */
    public static readonly LEAD_ZERO_DATE_TIME: boolean = true;

    public static readonly SHOW_MASK_TYPED: boolean = false;

    public static readonly SPECIAL_CHARACTERS: string[] = ['/'];

    public static readonly DROP_SPECIAL_CHARACTERS: boolean = false;

    public static readonly PLACE_HOLDER_CHARACTER: string = '_';

    public static readonly SHOWN_MASK_EXPRESSION: string = '00/00/0000';

    /**
     * Using date-aware tokens within the mask to ensure correct date formatting
     * and values.
     */
    public static readonly MASK: string = 'M0/d0/0000';
}
